import React from 'react';
import { useQuery } from '@apollo/client';
import { useDeps } from 'src/hooks/useDeps';
import { ImageAndHoverText } from 'src/elements/ImageAndHoverText/ImageAndHoverText';
import { imagePath } from 'src/util/formatUrl';
import categoriesQuery from 'src/queries/categories.graphql';

type Props = {
    categories: string[];
};

type CategoriesQueryItem = {
    name: string | null;
    image: string | null;
    id: number;
    url_path: string | null;
};

type CategoriesQueryData = {
    categories: {
        total_count: number;
        items: (CategoriesQueryItem | null)[] | null;
    } | null;
};

type CategoriesQueryVariables = {
    ids?: string[] | null;
    pageSize?: number | null;
    currentPage?: number | null;
};

export const IndustryCategories: React.FC<Props> = ({ categories }) => {
    const { loading, error, data } = useQuery<CategoriesQueryData, CategoriesQueryVariables>(categoriesQuery, {
        variables: {
            ids: categories.length > 0 ? categories : null,
            pageSize: 6,
            currentPage: 1,
        },
        ssr: useDeps().env.SSR_GQL,
        skip: categories.length === 0,
    });

    if (loading) return null;
    if (error) return null;
    if (!data || !data.categories || !data.categories.items) return null;

    const categoryItems = data.categories.items.filter(Boolean) as CategoriesQueryItem[];

    if (categoryItems.length === 0) return null;

    return (
        <>
            {categoryItems.map((category) => (
                <ImageAndHoverText
                    key={category.id}
                    title={category.name || 'unknown'}
                    link={category.url_path || 'unknown'}
                    image={imagePath(category.image)}
                    smallImage
                />
            ))}
        </>
    );
};
